// data: {
//   orderId: string;
//   sku: string;
//   quantity?: number;tsc_return_replacement
// }

//Return flow
function checkIfManifestDateExists(orderDetails) {
  console.log("prince-cancel","inside fun.");
  if (!orderDetails || !orderDetails.productsData || !Array.isArray(orderDetails.productsData)) {
    console.log("prince-cancel","orderDetails not found or is not an array.");
    return false; // Handle cases where the structure is not as expected
  }

  for (const product of orderDetails.productsData) {
    if (product.easyecom && product.easyecom.manifest_date) {
      return true;
    }
  }

  return false;
}


function checkIfOrderIsDelivered(orderDetails) {
  // Loop through each order in orderDetails array
  // for (const order of orderDetails) {
    // Loop through each product line in productsData
    const order = orderDetails;
    for (const product of order.productsData) {
      const history = product.easyecom && product.easyecom.clickpost_history;
      if (!history || history.length === 0) {
        continue; // if no history available, move to the next product
      }
      
      // Use reduce to determine the status with the latest creation_date_and_time
      const latestStatus = history.reduce((latest, status) => {
        // Create Date objects for accurate comparisons
        const latestDate = new Date(latest.creation_date_and_time);
        const currentDate = new Date(status.creation_date_and_time);
        return currentDate > latestDate ? status : latest;
      });

      console.log('prince-c-latestStatus', latestStatus);

      // Check if the latest status description is "Delivered"
      if (latestStatus.clickpost_status_description === "Delivered") {
        return true;
      }
    }
  // }
  return false;
}

function checkCancelEligibility(orderDetails) {
  const manifest = checkIfManifestDateExists(orderDetails);
  const delivered = checkIfOrderIsDelivered(orderDetails);

  if(!manifest && !delivered) {
    return true;
  }
  return false;
}

function isRequestRejected(orderDetails, requestId) {
  // Iterate over each order in the orderDetails array
  // for (const order of orderDetails) {
    // Iterate over each product line item
    const order = orderDetails;
    for (const product of order.productsData) {
      // Check if pos_request_detail exists and is an array
      if (product.pos_request_detail && Array.isArray(product.pos_request_detail)) {
        // Iterate over each request object in pos_request_detail array
        for (const request of product.pos_request_detail) {
          // Check for the provided request_id match
          if (request.request_id === requestId) {
            // Return true if the status is "rejected", else false
            return request.status === "rejected";
          }
        }
      }
    }
  // }
  // Return false if no matching request_id is found in any line item
  return false;
}

//Replacement flow
function getLatestStatusForRequest(apiResponse, targetRequestId) {
  const orderDetails = apiResponse;
  console.log('prince-orderDetails', orderDetails);

  // if (!orderDetails || !Array.isArray(orderDetails)) {
  //   console.log("orderDetails not found or is not an array.");
  //   return null;
  // }

  let matchingProduct = null;

  // Find the product that contains the request_id
  // for (const product of orderDetails) {
    if (orderDetails.productsData && Array.isArray(orderDetails.productsData)) {
      for (const productData of orderDetails.productsData) {
        console.log('prince-productData', productData);
        if (productData.pos_request_detail && Array.isArray(productData.pos_request_detail)) {
          const hasMatchingRequest = productData.pos_request_detail.some(
            (request) => request.request_id === targetRequestId
          );
          if (hasMatchingRequest) {
            matchingProduct = productData;
            break; // Found the product, no need to continue searching
          }
        }
      }
    }
    // if (matchingProduct) {
    //   break;
    // }
  // }

  if (!matchingProduct || !matchingProduct.pos_request_detail || !Array.isArray(matchingProduct.pos_request_detail)) {
    console.log(`No product found with request_id: ${targetRequestId}`);
    return null;
  }

  // Filter for requests matching the targetRequestId
  const matchingRequests = matchingProduct.pos_request_detail.filter(
    (request) => request.request_id === targetRequestId
  );

  if (matchingRequests.length === 0) {
    console.log(`No matching requests found for id: ${targetRequestId}`);
    return null;
  }

  // Sort by pos_request_date to find the latest
  matchingRequests.sort((a, b) => new Date(b.pos_request_date) - new Date(a.pos_request_date));

  // Return the status of the latest request
  return matchingRequests[0].status;
}

async function verifyOrderAndProduct(data, orderDetails) {
  const { orderId, sku, requestId, quantity = 1 } = data;

  if(requestId) {
    const myStatus = getLatestStatusForRequest(orderDetails, requestId);

    if(myStatus != 'rejected') {
      throw new Error('Request is already placed');
    }
    else if(myStatus == 'rejected') {
      sessionStorage.setItem('rejectedRequestId', requestId);
    }
  }
  

  // Extract order information from the OMS response
  const order = orderDetails;
  console.log('prince-fun-order', order);
  console.log('prince-fun-sku', sku);

  // Find all line items with the specified SKU
  const lineItems = order.productsData.filter(
    (item) => item.sku === sku,
  );

  if (lineItems.length === 0) {
    throw new Error('No line items found with the specified SKU');
  }

  // Check if the requested SKU is delivered
  if (!isSkuDelivered(lineItems)) {
    throw new Error('The requested SKU is not delivered');
  }

  // Determine eligibility based on request status and quantities
  const {
    isEligible,
    errorCode,
    eligibleQuantity,
  } = determineEligibility(lineItems, quantity);

  if (!isEligible) {
    throw new Error('The requested quantity exceeds the eligible quantity');
  }

  // Get SKU details

  // Parse order date from OMS data
  const orderDate = new Date(order.created_at);
  const reqDate = new Date();

  // const window = differenceInDays(reqDate, orderDate);

  //TODO: UNCOMMENT THIS BEFORE PROD MERGE
  // if (window > Number(requestWindow)) {
  //   throw new Error(errorCodes.DUE_DATE_PASS.CODE);
  // }

  // this.logger.log('Order and product verification successful');

  // Return the data in the format expected by placeRequest
  return {
    response: { order },
    lineItem: lineItems[0],
    order_id: order.order_id,
    eligibleQuantity,
  };
}

// Helper method to check if the requested SKU is delivered
function isSkuDelivered(lineItems) {
  for (const item of lineItems) {
    if (item.easyecom && item.easyecom.invoice_status === 'delivered') {
      return true;
    }
  }
  return false;
}

// Helper method to determine eligibility based on request status and quantities
// Helper method to determine eligibility based on request status and quantities
function determineEligibility(
  lineItems,
  requestedQuantity,
){
  let eligibleQuantity = 0;

  for (const lineItem of lineItems) {
    // Case 1: Line item has request ID (check pos_request_detail for status)
    if (
      lineItem.request_id &&
      lineItem.pos_request_detail &&
      lineItem.pos_request_detail.length > 0
    ) {
      // Find requests matching this line item's request ID
      const matchingRequests = lineItem.pos_request_detail.filter(
        (req) => req.request_id === lineItem.request_id,
      );

      if (matchingRequests.length > 0) {
        // Get the latest request by date
        const requestDetails = [...matchingRequests].sort(
          (a, b) =>
            new Date(b.pos_request_date).getTime() -
            new Date(a.pos_request_date).getTime(),
        );

        // Get the latest request status
        const latestRequest = requestDetails[0];

        // If latest status is 'rejected', this quantity is eligible
        if (latestRequest.status === 'rejected') {
          eligibleQuantity += lineItem.quantity;
        }
        // If latest status is 'created', this quantity is not eligible
        else if (latestRequest.status === 'created') {
          // No quantity added to eligible
        }
        // For other statuses
        else {
          // No quantity added to eligible
        }
      }
    }
    // Case 2: Line item has no request ID - fully eligible
    else {
      eligibleQuantity += lineItem.quantity;
    }
  }

  console.log(
    'eligibleQuantity',
    eligibleQuantity,
    'requestedQuantity',
    requestedQuantity,
  );

  // Check if requested quantity exceeds eligible quantity
  // if (requestedQuantity > eligibleQuantity) {
  //   return {
  //     isEligible: false,
  //     errorCode: 'The requested quantity exceeds the eligible quantity',
  //   };
  // }

  return { isEligible: true, eligibleQuantity };
}